import { i18n } from '@/i18n'

function rawIdFromItem(item) {
  if (item == null) {
    return null
  }
  if (typeof item === 'object' && 'id' in item) {
    return item.id
  }
  if (typeof item === 'object') {
    return null
  }
  return item
}

/**
 * Нормализация списка идентификаторов из API в строки (для SelectMulti / Choices).
 * @param {unknown} values
 * @returns {string[]}
 */
export function normalizeIdListToStrings(values) {
  if (!Array.isArray(values)) {
    return []
  }
  return values
    .map(rawIdFromItem)
    .filter(item => item !== null && item !== undefined && item !== '')
    .map(item => String(item))
}

/**
 * Сериализация массива id для тела запроса: целые числа, без дубликатов и без NaN.
 * Подходит для любых полей вида «multiselect по id» (Pack size RUS и т.п.).
 * @param {unknown} values
 * @returns {number[]}
 */
export function serializeIdList(values) {
  const normalized = []
  const seen = new Set()
  for (const item of values || []) {
    const itemId = Number.parseInt(rawIdFromItem(item), 10)
    if (Number.isNaN(itemId) || seen.has(itemId)) {
      continue
    }
    seen.add(itemId)
    normalized.push(itemId)
  }
  return normalized
}

/**
 * Нормализует поля-массивы id в строковые массивы у плоской модели (in-place).
 * @param {Record<string, any>} model
 * @param {string[]} fieldNames
 */
export function normalizeModelIdListFields(model, fieldNames) {
  for (const field of fieldNames) {
    model[field] = normalizeIdListToStrings(model[field])
  }
}

/**
 * Сериализует набор полей-массивов id из item в payload.
 * @param {Record<string, any>} item
 * @param {string[]} fieldNames
 * @returns {Record<string, number[]>}
 */
export function serializeItemIdListFields(item, fieldNames) {
  return Object.fromEntries(fieldNames.map(field => [field, serializeIdList(item[field])]))
}

/**
 * Форматирует массив dropdown id в строку значений для списков.
 * @param {unknown} values
 * @param {Array<Record<string, any>>} options
 * @returns {string}
 */
export function formatConfigIdList(values, options) {
  if (!Array.isArray(values)) {
    return ''
  }

  const labelsById = new Map((options || []).map(item => [String(item.id), item.value]))
  return values
    .map(item => labelsById.get(String(rawIdFromItem(item))))
    .filter(Boolean)
    .join(', ')
}

/**
 * Форматирует массив объектов в строку значений для списков.
 * @param {unknown} values
 * @param {(item: any) => unknown} pick
 * @returns {string}
 */
export function formatLabelList(values, pick = item => item?.value) {
  if (!Array.isArray(values)) {
    return ''
  }

  return values
    .map(item => pick(item))
    .filter(Boolean)
    .join(', ')
}

/**
 * Булево поле для списков: «Да» / «Нет» через i18n.
 * @param {unknown} value
 * @returns {string}
 */
export function formatBool(value) {
  return i18n.global.t(value ? 'common.yes' : 'common.no')
}
